import { ITopPartnersFiltersFormData } from './models'

export const COLORS = ['#b9d0ef', '#80aee8', '#5b9cf0', '#3e7dd1', '#2d6bc2', '#1c59b2']

// Set to true to include Market BPS / OPH alongside their WW flags in the
// existing Top BPS / Top OPH tabs (Reseller), as in the former dropdown groups.
// Applies only to Reseller; Distributor and Retail top flags remain available.
// Source flag data is preserved.
export const INCLUDE_MARKET_FLAGS = false

export const TOP_PARTNERS_MANAGEMENT_FORM_KEY = 'TOP_PARTNERS_MANAGEMENT_FORM_KEY'

export const TOP_PARTNERS_MANAGEMENT_INITIAL_FORM_DATA: ITopPartnersFiltersFormData = {
  countryCode: [],
  partnerId: [],
  requestStatus: null,
}
